import { iConfigColumn } from '../../../shared/UITypes/types';

export const FAULT_CATEGORY_PAGE_NAME = 'NCR Faults';
export const FAULT_CATEGORY_LIST_COLUMNS: Array<iConfigColumn> = [
  {
    name: 'Name',
    key: 'name',
    dataSource: ['id'],
    isSortable: true,
    type: 'edit-trigger',
    isSelected: true,
  },
  {
    name: 'Description',
    key: 'comments',
    dataSource: ['comments'],
    isSelected: true,
    type: 'text',
  },
  {
    name: 'Created',
    key: 'createdAt',
    dataSource: ['createdBy.firstName'],
    type: 'history',
    isSortable: false,
  },
  {
    name: 'Updated',
    key: 'updatedAt',
    dataSource: ['updatedBy.firstName'],
    type: 'history',
    isSortable: false,
  },
  {
    name: '',
    key: 'operation',
    dataSource: [],
    type: 'delete',
    isCompulsory: true,
    isSelected: true,
    group: '',
  },
];
